import Model from './Model'

class Address extends Model {
  static primaryKey = 'id'
  static entity = 'address'

  static fields () {
    return {
      id: this.attr(null),
      userid: this.attr(null),
      default_s: this.attr(null),
      default_b: this.attr(null),
      is_billing: this.attr(null),
      is_shipping: this.attr(null),
      title: this.attr(null),
      firstname: this.attr(null),
      lastname: this.attr(null),
      address: this.attr(null),
      city: this.attr(null),
      county: this.attr(null),
      state: this.attr(null),
      country: this.attr(null),
      zipcode: this.attr(null),
      phone: this.attr(null)
    }
  }
}

export default Address
